<template>
	<Modals
		:title="'Advanced Filters'"
		:display="true"
		@show="closeModal"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template slot="modal-content">
			<div :class="['advanced-filters', loading && 'is-disabled']">
				<div class="advanced-filters__primary">
					<div class="advanced-filters__group">
						<span class="advanced-filters__group-title"
							>General</span
						>
						<div
							class="advanced-filters__info"
							v-show="disableDatePicker"
						>
							<i class="icon icon-info"></i>
							<span>
								Custom filter applied to only show activity
								within the past hour.<br />
								<a
									class="link"
									v-on:click.prevent="clearCustomFilters"
									>Clear custom filter</a
								>
								to use Date Range.
							</span>
						</div>
						<DatePicker
							:disabled="disableDatePicker"
							labelText="Date Range"
							v-model="parseDate"
						/>
						<DropdownV2
							label="Direction"
							name="ddDirections"
							dropdownWidth="190px"
							:options="directionsOptions"
							v-model="dataFilters.direction"
							:placeholder="'Select one'"
						/>
					</div>
					<div class="advanced-filters__group">
						<span class="advanced-filters__group-title"
							>Quick Filters</span
						>
						<DropdownV2
							label="Transaction Types"
							name="ddTransactionTypes"
							dropdownWidth="190px"
							:options="transactionTypeOptions"
							:showClearSelectedButton="false"
							:placeholder="'All Types'"
							v-model="dataFilters.logEntrytransactionTypes"
						/>
						<DropdownMultiselectV2
							label="Customers"
							:options="customerValueOptions"
							:timeout="2000"
							placeholder="All Clients"
							v-model="dataFilters.customers"
						/>
						<DropdownMultiselectV2
							label="Health"
							:options="healthOptions"
							placeholder="All Health"
							v-model="dataFilters.healths"
						/>
					</div>
				</div>

				<div class="advanced-filters__secondary">
					<div
						class="advanced-filters__group"
						:class="{
							'is-disabled': !showThirdPartyVendorGroup
						}"
					>
						<span class="advanced-filters__group-title"
							>3P Vendor</span
						>
						<DropdownV2
							label="Method"
							name="dd3PVendorMethods"
							dropdownWidth="190px"
							:options="thirdPartyVendorMethodOptions"
							v-model="dataFilters.transactionMethod"
							:showClearSelectedButton="false"
							:placeholder="'Select One'"
						/>
						<DropdownV2
							label="Is Vendor an Integration Solution?"
							name="ddDMSIntegrationSolution"
							dropdownWidth="190px"
							:options="integrationSolutionOptions"
							v-model="dataFilters.isDMSIS"
							:placeholder="'Select One'"
						/>
						<DropdownMultiselectV2
							label="3P Vendor Integration"
							:options="thirdPartyVendorIntegrationsOpts"
							placeholder="Select one or more"
							v-model="dataFilters.integrationCodes"
						/>
					</div>
					<div
						class="advanced-filters__group"
						:class="{
							'is-disabled': !showOEMGroup
						}"
					>
						<span class="advanced-filters__group-title">OEM</span>
						<DropdownV2
							label="Manufacturer"
							name="ddManufacturer"
							dropdownWidth="190px"
							:autosuggestion="true"
							:options="manufacturersOptions"
							v-model="dataFilters.oemManufacturer"
							:placeholder="'Select One'"
							@change="onOEMNameChanged"
						/>
						<DropdownV2
							label="Method"
							name="ddOEMMethods"
							dropdownWidth="190px"
							:options="oemMethodOptions"
							v-model="dataFilters.oemMethod"
							:placeholder="'Select One'"
							@change="onOEMMethodChanged"
						/>

						<DropdownV2
							label="Integration Name"
							name="ddOEMIntegrationName"
							dropdownWidth="190px"
							:autosuggestion="true"
							:options="oemIntegrationsOptions"
							v-model="dataFilters.oemIntegrationName"
							:placeholder="'Select One'"
							@change="onIntegationNameChanged"
						/>
					</div>

					<div
						class="advanced-filters__group"
						:class="{
							'is-disabled': !showVueDmsInternalGroup
						}"
					>
						<div class="advanced-filters__group-dms">
							<span class="advanced-filters__group-title"
								>VUE DMS Internal</span
							>
							<IconInfo
								class="advanced-filters__group-dms-info"
								:text="infoValue"
								:position="position"
								:fontSize="'16px'"
							/>
						</div>

						<DropdownV2
							label="Filter"
							name="ddRequest"
							dropdownWidth="190px"
							:autosuggestion="true"
							:options="otherRequestTypeOptions"
							v-model="dataFilters.requestType"
							:placeholder="'Select One'"
						/>

						<DropdownV2
							label="Source"
							name="ddSource"
							dropdownWidth="190px"
							:autosuggestion="true"
							:options="otherSourcesOptions"
							v-model="dataFilters.otherSource"
							:placeholder="'Select One'"
						/>
					</div>
				</div>
			</div>
			<Spinner :processor="{ loading: true }" v-if="loading" />
		</template>
		<template #modal-footer>
			<ButtonGroup
				:class="[loading && 'is-disabled']"
				:items="[
					{
						id: `save-${uid}`,
						className: 'btn--primary',
						labelText: 'Apply',
						type: 'submit',
						disabled: hasfiltersChanges,
						btnClick: applyAction
					},
					{
						id: `cancel-${uid}`,
						className: 'btn--link',
						labelText: 'Cancel',
						btnClick: closeModal
					}
				]"
			/>
		</template>
	</Modals>
</template>
<script>
import DatePicker from '@/components/forms/date-picker/date-picker';
import DropdownMultiselectV2 from '@/components/forms/dropdown/dropdown-multiselect-v2.vue';
import DropdownV2 from '@/components/forms/dropdown/dropdown-v2.vue';
import Modals from '@/components/shells/modal/modals';
import CustomerOptionsMixins from '@/mixins/customers/customer-options';
import ButtonGroup from '@/components/forms/button/button-group';
import { mapActions, mapGetters, mapState } from 'vuex';
import IconInfo from '@/components/notifications/icon-info/icon-info';
import Spinner from '@/components/visual/spinner/spinner';
//const
import {
	logEntrytransactionTypes,
	RequestTypes
} from '@/sections/transactions/shared/transactions-filters-params';

import {
	SET_SETTINGS_TRANSACTIONS,
	SETTINGS_TRANSACTIONS
} from '@/sections/transactions/shared/apisettings-mutation-types.js';

import {
	MODULE_NAME as MODULE_OPTION_NAME,
	REQUEST_TYPES,
	SET_REQUEST_TYPES,
	SET_OEM_LOGS,
	OEM_LOGS,
	INTEGRATIONS
} from '@/sections/options/options-mutation-type.js';
import { INTEGRATIONS_OPTIONS } from '@/sections/options/options-mutation-type.js';

import { deepEqual as objCompare } from '@/utils/object';

//libraries
import { formatDate } from '@/utils/datetime';
import { parse } from 'date-fns';
import _ from 'lodash';

export default {
	name: 'GlobalTransactionsAdvancedFilters',
	mixins: [CustomerOptionsMixins],
	components: {
		DatePicker,
		DropdownV2,
		DropdownMultiselectV2,
		Modals,
		ButtonGroup,
		Spinner,
		IconInfo
	},
	props: {
		filters: {
			type: Object,
			default: () => {}
		},
		position: {
			type: String,
			default: 'top'
		}
	},
	data() {
		return {
			dataFilters: {},
			transactionTypeOptions: [],
			healthOptions: [],
			thirdPartyVendorMethodOptions: [],
			directionsOptions: [],
			integrationSolutionOptions: [],
			manufacturersOptions: [],
			oemIntegrationsOptions: [],
			oemMethodOptions: [],
			otherSourcesOptions: [],
			otherRequestTypeOptions: [],
			loading: false,
			infoValue:
				"These are the transactions between VUE and internally used APIs such as SignalR, 'SecureVueLogEntry', 'OemGenericLogEntry', and 'DcsTransactionLogEntry'.",
			customerValueOptions: [],
			selectedCustomers: []
		};
	},
	created() {
		this.customerValueOptions = this.OptionsCustomers.items.map(option => ({
			text: option.text,
			value: option.value
		}));

		this.dataFilters = { ...this.filters };
		this.executePayload([...this.getThirdPartyTransactionPayload()]);
	},
	computed: {
		...mapGetters('settingstransactions', [SETTINGS_TRANSACTIONS]),
		...mapGetters(MODULE_OPTION_NAME, [
			REQUEST_TYPES,
			OEM_LOGS,
			'OptionsCustomers'
		]),
		...mapState(MODULE_OPTION_NAME, [INTEGRATIONS]),
		...mapState('options', [INTEGRATIONS_OPTIONS]),

		hasfiltersChanges() {
			return objCompare(this.dataFilters, this.filters, true['search']);
		},
		disableDatePicker() {
			return !!this.dataFilters.primaryIntegrationVendorId;
		},
		parseDate: {
			get() {
				if (this.dataFilters.minDatetime) {
					return {
						startDate: parse(
							this.dataFilters.minDatetime,
							'MM-dd-yyyy',
							new Date()
						),
						endDate: parse(
							this.dataFilters.maxDatetime,
							'MM-dd-yyyy',
							new Date()
						)
					};
				} else {
					return {
						startDate: parse(
							this.filters.minDatetime,
							'MM-dd-yyyy',
							new Date()
						),
						endDate: parse(
							this.filters.maxDatetime,
							'MM-dd-yyyy',
							new Date()
						)
					};
				}
			},
			set(value) {
				if (value.startDate) {
					this.dataFilters.minDatetime = formatDate(value.startDate);
					this.dataFilters.maxDatetime = formatDate(value.endDate);
				} else {
					this.dataFilters.minDatetime = this.filters.minDatetime;
					this.dataFilters.maxDatetime = this.filters.maxDatetime;
				}
			}
		},
		showThirdPartyVendorGroup() {
			return (
				this.dataFilters.logEntrytransactionTypes ===
				logEntrytransactionTypes.ThirdPartyVendor
			);
		},
		showOEMGroup() {
			return (
				this.dataFilters.logEntrytransactionTypes ===
				logEntrytransactionTypes.Oem
			);
		},
		showVueDmsInternalGroup() {
			return (
				this.dataFilters.logEntrytransactionTypes ===
				logEntrytransactionTypes.VueDmsInternal
			);
		},
		thirdPartyVendorIntegrationsOpts() {
			const integrations = _.get(this[INTEGRATIONS_OPTIONS], 'items', []);

			if (integrations.length > 0) {
				return integrations.map(item => ({
					disabled: !item.active,
					value: item.value,
					text: `${item.text} (${item.value})`
				}));
			}
			return [];
		}
	},
	methods: {
		...mapActions(MODULE_OPTION_NAME, {
			getRequestTypesAPI: SET_REQUEST_TYPES,
			getOemLogsAPI: SET_OEM_LOGS
		}),
		...mapActions('settingstransactions', {
			getTransactionSettings: SET_SETTINGS_TRANSACTIONS
		}),
		async getApiTransactionSettings() {
			await this.getTransactionSettings().then(res => {
				this.fillSettingOptions(this, res);
			});
		},
		async getRequestTypes(obj) {
			await this.getRequestTypesAPI(obj).then(() => {
				if (obj.propertyName === RequestTypes.transactionType) {
					this.setOtherRequestTypeOptions();
				}
				if (obj.propertyName === RequestTypes.sourceApplication) {
					this.setOtherSourcesOptions();
				}
			});
		},
		async getOEMLogs() {
			await this.getOemLogsAPI().then(() => {
				this.setDefaultOEMDropdowns();
			});
		},
		mapOptions(res, filter) {
			let options = [];

			if (res) {
				options = [...res];
				options = options.map(x => {
					return {
						text: filter == '' ? x : x.description,
						value:
							filter == 'value'
								? x.value
								: filter == ''
								? x
								: x.description
					};
				});
			}

			return options;
		},
		closeModal() {
			this.$emit('close');
		},
		applyAction() {
			this.$emit('filtersChanged', { ...this.dataFilters });
			this.closeModal();
		},
		executePayload(payload) {
			if (payload.length > 0) {
				this.loading = true;
				Promise.all(payload).then(() => {
					this.loading = false;
				});
			}
		},
		getOEMTransactionPayload() {
			let payload = [];
			if (_.isEmpty(this[OEM_LOGS])) {
				payload.push(this.getOEMLogs());
			} else {
				this.setDefaultOEMDropdowns();
			}
			return payload;
		},
		getThirdPartyTransactionPayload() {
			let payload = [];
			if (_.isEmpty(this[SETTINGS_TRANSACTIONS])) {
				payload.push(this.getApiTransactionSettings());
			} else {
				this.fillSettingOptions(this, {
					...this[SETTINGS_TRANSACTIONS]
				});
			}
			return payload;
		},
		fillSettingOptions(self, response) {
			self.healthOptions = response.health.map(item => {
				return {
					text: item.text,
					value: item.value
				};
			});
			self.transactionTypeOptions = response.transactionType.map(
				item => ({
					disabled: item.value !== 'ThirdPartyVendor', //TODO: remove after the first stage of testing for the 3P vendor
					value: item.value,
					text: item.text
				})
			);
			self.thirdPartyVendorMethodOptions = response.thirdPartyVendorMethod.map(
				item => {
					return {
						disabled: item.value !== 'SecureVue', //TODO: remove after the first stage of testing for the 3P vendor
						text: item.text,
						value: item.value
					};
				}
			);
			self.directionsOptions = response.direction.map(item => {
				return {
					text: item.text,
					value: item.value
				};
			});
			self.integrationSolutionOptions = response.integrationSolution.map(
				item => {
					return {
						text: item.text,
						value: `${item.text.toLowerCase() == 'yes'}` //ask yoel
					};
				}
			);
		},
		getOtherRequestTypePayload() {
			let payload = [];
			if (_.isEmpty(this[REQUEST_TYPES](RequestTypes.transactionType))) {
				payload.push(
					this.getRequestTypes({
						propertyName: RequestTypes.transactionType
					})
				);
			} else {
				this.setOtherRequestTypeOptions();
			}
			return payload;
		},
		getOtherSourcePayload() {
			let payload = [];
			if (
				_.isEmpty(this[REQUEST_TYPES](RequestTypes.sourceApplication))
			) {
				payload.push(
					this.getRequestTypes({
						propertyName: RequestTypes.sourceApplication
					})
				);
			} else {
				this.setOtherSourcesOptions();
			}
			return payload;
		},
		setOtherRequestTypeOptions() {
			this.otherRequestTypeOptions = this.mapOptions(
				this[REQUEST_TYPES](RequestTypes.transactionType),
				'value'
			);
		},
		setOtherSourcesOptions() {
			this.otherSourcesOptions = this.mapOptions(
				this[REQUEST_TYPES](RequestTypes.sourceApplication),
				'value'
			);
		},
		formatDropDownData(data) {
			function onlyUnique(value, index, self) {
				return self.indexOf(value) === index;
			}
			let result = data.filter(onlyUnique);
			return this.mapOptions(result, '');
		},
		getManufactures() {
			const methodSelected = this.dataFilters.oemMethod;
			const integrationSelected = this.dataFilters.oemIntegrationName;

			let oemNames = [];
			let data = this[OEM_LOGS];

			if (methodSelected) {
				data = data.filter(x => x.integrationType == methodSelected);
			}

			if (integrationSelected) {
				data = data.filter(
					x => x.transactionType == integrationSelected
				);
			}

			data.forEach(x => oemNames.push(x.oem));
			return this.formatDropDownData(oemNames);
		},
		getOemMethod() {
			const oemSelected = this.dataFilters.oemManufacturer;
			const integrationSelected = this.dataFilters.oemIntegrationName;

			let data = this[OEM_LOGS];
			let oemMethods = [];

			if (oemSelected) {
				data = data.filter(x => x.oem == oemSelected);
			}

			if (integrationSelected) {
				data = data.filter(
					x => x.transactionType == integrationSelected
				);
			}
			data.forEach(x => oemMethods.push(x.integrationType));
			return this.formatDropDownData(oemMethods);
		},
		getOemIntegrationNames() {
			const oemSelected = this.dataFilters.oemManufacturer;
			const methodSelected = this.dataFilters.oemMethod;

			let integrationNames = [];
			let data = this[OEM_LOGS].filter(item => item.transactionType);

			if (oemSelected) {
				data = data.filter(x => x.oem == oemSelected);
			}

			if (methodSelected) {
				data = data.filter(x => x.integrationType == methodSelected);
			}

			data.forEach(x => integrationNames.push(x.transactionType));
			return this.formatDropDownData(integrationNames);
		},
		onOEMNameChanged(value) {
			if (value) {
				this.oemIntegrationsOptions = this.getOemIntegrationNames();
				this.oemMethodOptions = this.getOemMethod();
			} else {
				this.setDefaultOEMDropdowns();
			}
		},
		onOEMMethodChanged(value) {
			if (value) {
				this.oemIntegrationsOptions = this.getOemIntegrationNames();
				this.manufacturersOptions = this.getManufactures();
			} else {
				this.setDefaultOEMDropdowns();
			}
		},
		onIntegationNameChanged(value) {
			if (value) {
				this.oemMethodOptions = this.getOemMethod();
				this.manufacturersOptions = this.getManufactures();
			} else {
				this.setDefaultOEMDropdowns();
			}
		},
		setDefaultOEMDropdowns() {
			this.manufacturersOptions = this.getManufactures();
			this.oemMethodOptions = this.getOemMethod();
			this.oemIntegrationsOptions = this.getOemIntegrationNames();
		},
		clearCustomFilters() {
			if (this.disableDatePicker) {
				this.dataFilters.primaryIntegrationVendorId = 0;
			}
		}
	},
	watch: {
		'dataFilters.logEntrytransactionTypes': {
			handler(val) {
				if (val === 'OEM') {
					this.executePayload([...this.getOEMTransactionPayload()]);
				}
				if (val === 'VueDMSInternal') {
					this.executePayload([
						...this.getOtherRequestTypePayload(),
						...this.getOtherSourcePayload()
					]);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Advanced Filters Modal
    * Can use SCSS variables = TRUE
    *
 */

.advanced-filters {
	display: grid;
	grid-template-columns: 1fr;
	gap: $gutter-xl;
	overflow: auto;
	@include scrollbar;

	@include mq($from: md) {
		min-width: 520px;
		max-height: calc(87vh - 320px);
	}

	@include mq($from: lg) {
		grid-template-columns: 284px 260px 260px;
	}

	&__primary,
	&__secondary {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-xl;
	}

	&__primary {
		@include mq($from: lg) {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			border-right: 1px solid $neutral-3;
			padding-right: $padding-lg;

			.advanced-filters__group {
				grid-template-columns: 1fr;

				&-title {
					grid-column: 1 / 2;
				}
			}
		}
	}

	&__secondary {
		@include mq($from: lg) {
			grid-column: 2 / 4;
		}
	}

	&__info {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: $gutter-md;
		@include body-text('sm');
		color: $neutral-2;

		.icon {
			font-size: 14px;
		}
	}

	&__group {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-lg;

		@include mq($from: sm-l) {
			grid-template-columns: 1fr 1fr;
			column-gap: $gutter-xl;
		}

		&-title {
			@include heading('md');

			@include mq($from: sm-l) {
				grid-column: 1 / 3;
			}
		}

		&-dms {
			grid-column: 1 / 3;
			display: flex;
			gap: $gutter-md;
		}

		&-dms-info {
			max-height: 18px; //Tweak to center IconInfo with Heading line-height
		}
	}
}
</style>
